import Categories from './categories'

export default Categories